<template>
  <div class="divBaseCourse" v-lazy:background-image="{
      src: baseBgUrl,
      loading: require('./../../../../../assets/wheelplanting.jpg'),
    }">
    <common-title-widge
      :title="baseTitle"
      :desc="baseDescrible"
      :bgFont="baseBg"
      class="baseCourse_title"
    ></common-title-widge>
    <div class="divContent">
      <div v-for="item in baseDetails" :key="item.url" class="divItem">
        <div>
          <div class="item_img"><img :src="item.url" alt /></div>
          <div class="divItemFont">
            <div v-for="v in dataConvert(item.desc)" :key="v" class="item_font">
              {{ v }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitleWidge from "../asserts/common/components/commonTitleWidge";
export default {
  components: {
    commonTitleWidge,
  },
  props: {
    baseTitle: {
      type: String,
      default: "",
    },
    baseDescrible: {
      type: String,
      default: "",
    },
    baseBg: {
      type: String,
      default: "",
    },
    baseDetails: {
      type: Array,
      default: function() {
        return [];
      },
    },
    baseBgUrl: {
      type: String,
      default: "",
    },
  },
  methods: {
    dataConvert(str) {
      return str
        .replace(/[\n]/g, "")
        .trimRight()
        .split(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../asserts/scss/baseCourseWidget.scss";
</style>
